namespace Matrix.Administration {
    export interface PermissionSetPermissionRow {
        PermissionSetCode?: string;
        PermissionKey?: string;
        IsActive?: boolean;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        PermissionSetCodeName?: string;
        PermissionSetCodeDefaultPermissions?: string;
    }

    export namespace PermissionSetPermissionRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'PermissionSetCode';
        export const localTextPrefix = 'Administration.PermissionSetPermission';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            PermissionSetCode = "PermissionSetCode",
            PermissionKey = "PermissionKey",
            IsActive = "IsActive",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            PermissionSetCodeName = "PermissionSetCodeName",
            PermissionSetCodeDefaultPermissions = "PermissionSetCodeDefaultPermissions"
        }
    }
}
